import L from 'leaflet';
import React from 'react';

export const fellasMarkerIcon = L.divIcon({
  className: 'fellas-map-marker-pin',
  html: `
    <div style="width: 36px; height: 46px; position: relative; pointer-events: auto;">
      <svg width="36" height="46" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block; width: 36px; height: 46px; filter: drop-shadow(0 3px 6px rgba(0,0,0,0.45)); cursor: grab;">
        <path d="M12 0C5.37 0 0 5.37 0 12c0 9 12 20 12 20s12-11 12-20c0-6.63-5.37-12-12-12z" fill="#FF42B3" stroke="#FFFFFF" stroke-width="1.5"/>
        <circle cx="12" cy="11" r="4.5" fill="#FFFFFF"/>
      </svg>
    </div>
  `,
  iconSize: [36, 46],
  iconAnchor: [18, 46],
});

export const currentLocationIcon = L.divIcon({
  className: 'fellas-current-location-marker',
  html: `
    <div style="width: 24px; height: 24px; position: relative;">
      <span style="position: absolute; inset: 0; border-radius: 9999px; background-color: #38bdf8; opacity: 0.75; animation: ping 1.5s cubic-bezier(0,0,0.2,1) infinite;"></span>
      <span style="position: relative; display: block; border-radius: 9999px; width: 24px; height: 24px; background-color: #0284c7; border: 2.5px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></span>
    </div>
  `,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

export const FellasPin: React.FC = () => null;
